const dualList = {
  pickedAmount: 'נבחרו {{picked}} מתוך {{total}} פריטים',
};

export default dualList;
